export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  CONSULTANT = 'consultant',
  CLIENT = 'client',
  CONTRACTOR = 'contractor'
}

export interface ContractorProfile {
  useCases?: string[];
  clientTestimonials?: ClientTestimonial[];
  recentWork?: RecentWork[];
  portfolio?: PortfolioItem[];
}

export interface ClientTestimonial {
  id: string;
  clientName: string;
  clientCompany?: string;
  testimonial: string;
  rating: number;
  date?: Date;
}

export interface RecentWork {
  id: string;
  title: string;
  description: string;
  clientName?: string;
  completedDate?: Date;
  category?: string;
}

export interface PortfolioItem {
  id: string;
  title: string;
  description: string;
  imageUrl?: string;
  link?: string;
  category?: string;
  tags?: string[];
}

export interface User {
  id: string;
  username: string;
  email: string;
  role: UserRole;
  name: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
  contractorProfile?: ContractorProfile;
  company?: Company;
  createdAt?: string;
  updatedAt?: string;
}

export interface Company {
  id: string;
  name: string;
  address?: string;
  website?: string;
}

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface UpdateUserRequest {
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  oldPassword?: string;
  photo?: { id: string; path?: string };
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  token?: string;
  refreshToken?: string;
}
